'use strict'

import $ from 'jquery'

export default function () {
    $(document).ready(function () {
        if ($(document).width() > 1022) {
            var menu = $('.left-bloc .menu');
            var menuTop = menu.offset().top;
            var stopScroll = ($('section[id*=section]').last().offset().top + $('section[id*=section]').last().height()) - (menu.height() + 25);

            $(window).on('scroll', function () {
                var scrollTop = $(window).scrollTop() + 120;

                if (scrollTop > menuTop && scrollTop < stopScroll) {
                    menu.removeClass('menu-static').addClass('menu-fixed');
                    menu.removeAttr('style');
                    window.fixScrollTop = scrollTop;
                    window.fixMenuTop = menuTop;
                } else if (scrollTop >= stopScroll) {
                    menu.removeClass('menu-fixed').addClass('menu-static');
                    $('.menu-static').css('top', (window.fixScrollTop - window.fixMenuTop) + 'px');
                } else {
                    menu.removeClass('menu-fixed menu-static');
                    menu.removeAttr('style');
                }
            });
        }

        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();

            var target = $(this.getAttribute('href'));

            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 110
                }, 800);
            }
        });
    });
}
